import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ApprovalDialogSection = ({ ctx }) => {
  const {
    approvalDialogOpen,
    approvalRemarks,
    handleApproveInward,
    handleRejectInward,
    materials,
    selectedInward,
    setApprovalDialogOpen,
    setApprovalRemarks
  } = ctx;
  return (
    <>
      <Dialog open={approvalDialogOpen} onOpenChange={setApprovalDialogOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl">Approve Material Inward</DialogTitle>
          </DialogHeader>
          {selectedInward && (
            <div className="space-y-4 mt-4">
              <div className="p-4 bg-slate-50 rounded-sm">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-mono text-sm text-primary">{selectedInward.grn_number}</p>
                    <p className="font-medium text-lg">{materials.find(m => m.id === selectedInward.material_id)?.name}</p>
                    <p className="text-sm text-slate-500">{selectedInward.date}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-mono text-2xl font-bold">{selectedInward.quantity}</p>
                    <p className="text-sm text-slate-500">@ ₹{selectedInward.entered_rate}</p>
                  </div>
                </div>
              </div>
              
              {selectedInward.requires_rate_approval && (
                <div className="p-3 bg-amber-50 border border-amber-200 rounded-sm">
                  <p className="text-sm text-amber-800">
                    <strong>Rate Approval Needed:</strong> Entered rate ₹{selectedInward.entered_rate} vs Stock Register rate ₹{selectedInward.stock_register_rate || materials.find(m => m.id === selectedInward.material_id)?.rate || 0} ({selectedInward.rate_variance_percent?.toFixed(1)}% variance exceeds ±3% limit)
                  </p>
                </div>
              )}
              
              {selectedInward.requires_quantity_approval && (
                <div className="p-3 bg-amber-50 border border-amber-200 rounded-sm">
                  <p className="text-sm text-amber-800">
                    <strong>Quantity Approval Needed:</strong> Quantity exceeds remaining requirement
                  </p>
                </div>
              )}
              
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Approval Remarks</label>
                <textarea
                  value={approvalRemarks}
                  onChange={(e) => setApprovalRemarks(e.target.value)}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  rows="2"
                  placeholder="Optional remarks for approval..."
                />
              </div>
              
              <div className="flex justify-end space-x-3 pt-4">
                <button 
                  onClick={() => setApprovalDialogOpen(false)} 
                  className="btn-outline"
                >
                  Cancel
                </button>
                <button 
                  onClick={() => handleRejectInward(selectedInward.id, approvalRemarks)}
                  className="btn-outline text-error border-error hover:bg-error/10"
                >
                  Reject
                </button>
                <button 
                  onClick={() => handleApproveInward(selectedInward.id, true, true, approvalRemarks)}
                  className="btn-primary"
                >
                  Approve
                </button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ApprovalDialogSection;
